import { ComparisonOperators } from '@contentsquare/fov-constants';
export const landingPathCondition = {
    id: 'landing-path',
    category: 'behaviors',
    value: {
        operatorValues: [
            { value: ComparisonOperators.MATCH_EQUALS, label: 'CONDITION_SELECT_IS_EQUAL_TO_MALE' },
            { value: ComparisonOperators.MATCH_REGEX, label: 'CONDITION_SELECT_CONTAINS' },
            { value: ComparisonOperators.IS_EMPTY, label: 'CONDITION_SELECT_IS_EMPTY' },
        ],
    },
};
//# sourceMappingURL=landing-path-condition.value.js.map